import { render, staticRenderFns } from "./ChooseItRightPreview.vue?vue&type=template&id=3cdad14c&lang=pug&"
import script from "./ChooseItRightPreview.vue?vue&type=script&lang=js&"
export * from "./ChooseItRightPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports